import { combineReducers } from "redux";
import { questionsPage } from "components/Pages/Questions/reducer";
import { settingsActivity } from "components/Pages/Settings/SettingsActivity/reducer";
import { modalBillingPayment } from "components/Common/ModalBillingPayment/reducer";
import { modalBillingPlans } from "components/Common/ModalBillingPlans/reducer";
import { modalBillingCustomer } from "components/Common/ModalBillingCustomer/reducer";
import { modal } from "components/Common/Modal/reducer";
import { modalProfile } from "components/Common/ModalProfile/reducer";
import { modalResponseDetails } from "components/Common/ModalResponseDetails/reducer";
import { modalSessionTimeout } from "components/Common/ModalSessionTimeout/reducer";
import { conversationsList } from "components/Pages/Conversations/ConversationsList/reducer";
import { settingsSecurity } from "components/Common/ModalProfile/ModalProfileSecurity/reducer";
import { settingsTeam } from "components/Pages/Settings/SettingsTeam/reducer";
import { login } from "components/Pages/Login/reducer";
import { responsesPage } from "components/Pages/Responses/reducer";
import { responseEditorTrainerPage } from "components/Pages/Responses/ResponsesEditor/ResponseEditorTrainer/reducer";
import { root } from "components/reducer";
import { newResponseModal } from "components/Pages/Responses/ResponsesSideBar/NewResponseModal/reducer";
import { greetings } from "components/Pages/Settings/SettingsGreetings/reducer";
import { modalBotRoutingConfig } from "components/Pages/Settings/SettingsHandoff/ModalBotRoutingConfig/reducer";
import { authenticationModal, authenticationList } from "components/Pages/Settings/SettingsAuthentication/reducer";
import { settingsScheduledBlockSchedules } from "components/Pages/Settings/SettingsSchedules/reducer";
import { settingsScheduleModal } from "components/Pages/Settings/SettingsSchedules/SettingsSchedulesModal/reducer";
import { modalOpenState } from "./modal/reducer";
import { warnings } from "./warnings/reducer";
import { zendeskLADepartments, nuanceLABusinessUnits, nuanceLAAgents } from "./liveAgent/reducer";
import { zendeskDepartments } from "./zendesk/reducer";
import { billingPlan } from "./billingPlan/reducer";
import { activities } from "./activities/reducer";
import { notices } from "./notices/reducer";
import { expressions } from "./expressions/reducer";
import { variables } from "./variables/reducer";
import { error } from "./error/reducer";
import { tags } from "./tags/reducer";
import { logs } from "./logs/reducer";
import { responses } from "./responses/reducer";
import { responsesLoaded } from "./responsesLoaded/reducer";
import { responsesSideBar } from "./responsesSideBar/reducer";
import { windowAlert } from "./windowAlert/reducer";
import { alert } from "./alerts/reducer";
import { platformsReducer } from "./platforms/reducer";
import { session } from "./session/reducer";
import { globalReducer as global } from "./global/reducer";
import auths from "./auths/reducer";
import pages from "./pages";
import resources from "./resources";
import dragAndDrop from "./dragAndDrop";

/**
 * @typedef {Object} RootState
 * @property {Immutable.List<ResponseRecord>} responses
 */

/**
 * @type {Reducer<RootState>}
 */
const combinedReducer = combineReducers({
  activities,
  alert,
  auths,
  windowAlert,
  billingPlan,
  conversationsList,
  error,
  expressions,
  questionsPage,
  global,
  login,
  logs,
  modal,
  modalBillingPayment,
  modalBillingPlans,
  modalBillingCustomer,
  modalBotRoutingConfig,
  modalProfile,
  modalResponseDetails,
  modalSessionTimeout,
  newResponseModal,
  platforms: platformsReducer,
  responseEditorTrainerPage,
  pages,
  resources,
  responses,
  responsesLoaded,
  responsesSideBar,
  responsesPage,
  root,
  session,
  settingsActivity,
  settingsScheduledBlockSchedules,
  settingsScheduleModal,
  settingsSecurity,
  settingsTeam,
  tags,
  variables,
  notices,
  greetings,
  zendeskDepartments,
  zendeskLADepartments,
  nuanceLABusinessUnits,
  nuanceLAAgents,
  authenticationModal,
  authenticationList,
  modalOpenState,
  warnings,
  dragAndDrop
});

const appReducer = (state, action) => {
  let newState = state;

  // Clear store when unauthenticating
  // Client can be kept since it doesn't require authentication
  if (
    action.type === "UNAUTHENTICATE_SUCCESS" ||
    action.type === "UNAUTHENTICATE_FAILURE" ||
    action.type === "AUTO_LOGIN_FAILURE"
  ) {
    newState = {
      resources: {
        client: state.resources.client
      }
    };
  }

  return combinedReducer(newState, action);
};

export default appReducer;
